function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#C6CCD0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.29823 10.5978L7.16004 10.3214H6.85101H4.862C4.66278 10.3214 4.5 10.1586 4.5 9.95947V5.362C4.5 5.1628 4.6628 5 4.862 5H10.6381H11.1381C11.3372 5 11.5 5.16278 11.5 5.362V9.95947C11.5 10.1587 11.3372 10.3215 11.1381 10.3215H9.14905H8.84004L8.70184 10.5978L8.04309 11.9152L8.04308 11.9152C8.02704 11.9473 8.01183 11.9689 8 11.9828C7.98817 11.9689 7.97296 11.9473 7.95692 11.9153C7.95692 11.9153 7.95692 11.9153 7.95692 11.9152L7.29823 10.5978Z",
  fill: "#C6CCD0",
  stroke: "white"
});

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.9fbe4845.svg";
export { ForwardRef as ReactComponent };